/*
 * Watches for scrolling without pointer or keyboard input. If input stays unavailable,
 * it warns in the console and shows a reload banner using plain DOM.
 */

const SCROLL_RECENT_MS = 60000;
const INPUT_IDLE_MS = 180000;
const CHECK_EVERY_MS = 30000;
const RECOVERY_GRACE_MS = 60000;
const BANNER_ID = 'bha-input-watchdog-banner';

const state = {
  lastInputAt: Date.now(),
  lastScrollAt: 0,
  lastHiddenAt: 0,
  recoveryAt: 0,
  recoveries: 0,
  bannerShown: false
};

function showBanner() {
  if (state.bannerShown || document.getElementById(BANNER_ID)) {
    return;
  }
  state.bannerShown = true;
  const banner = document.createElement('div');
  banner.id = BANNER_ID;
  banner.setAttribute('role', 'alert');
  banner.style.cssText = [
    'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:2147483647',
    'background:#403788', 'color:#fff', 'padding:12px 16px', 'text-align:center',
    'font-family:Roboto,Arial,sans-serif', 'font-size:14px',
    'box-shadow:0 2px 8px rgba(0,0,0,.3)'
  ].join(';');
  banner.appendChild(document.createTextNode(
    'This page has stopped responding to clicks. Reload to continue; your saved work is not lost.'
  ));
  const reloadButton = document.createElement('button');
  reloadButton.type = 'button';
  reloadButton.textContent = 'Reload page';
  reloadButton.style.cssText = 'margin-left:12px; padding:4px 12px; border:1px solid #fff; background:transparent; color:#fff; border-radius:4px; cursor:pointer';
  reloadButton.addEventListener('click', () => window.location.reload());
  banner.appendChild(reloadButton);
  const dismissButton = document.createElement('button');
  dismissButton.type = 'button';
  dismissButton.textContent = 'Dismiss';
  dismissButton.style.cssText = 'margin-left:12px; padding:4px 12px; border:1px solid #fff; background:transparent; color:#fff; border-radius:4px; cursor:pointer';
  dismissButton.addEventListener('click', () => {
    removeBanner();
    state.recoveryAt = 0;
    state.lastInputAt = Date.now();
  });
  banner.appendChild(dismissButton);
  document.body.appendChild(banner);
}

function removeBanner() {
  const banner = document.getElementById(BANNER_ID);
  if (banner && banner.parentNode) {
    banner.parentNode.removeChild(banner);
  }
  state.bannerShown = false;
}

function check() {
  const now = Date.now();
  if (document.visibilityState !== 'visible') {
    return;
  }
  // Time spent on another tab does not count as the user being ignored.
  if (state.lastHiddenAt && now - state.lastHiddenAt < INPUT_IDLE_MS) {
    return;
  }
  const userIsPresent = now - state.lastScrollAt < SCROLL_RECENT_MS;
  const inputIsDead = now - state.lastInputAt > INPUT_IDLE_MS;

  if (!userIsPresent || !inputIsDead) {
    if (state.bannerShown && !inputIsDead) {
      removeBanner();
      state.recoveryAt = 0;
    }
    return;
  }

  if (!state.recoveryAt) {
    state.recoveryAt = now;
    state.recoveries += 1;
    console.warn('[bha] input watchdog: scrolling but no pointer or key event for '
      + Math.round((now - state.lastInputAt) / 1000) + 's. Waiting to see if input recovers.');
    return;
  }

  if (now - state.recoveryAt > RECOVERY_GRACE_MS) {
    console.error('[bha] input watchdog: page is still not accepting input after waiting. '
      + 'A reload is needed.');
    showBanner();
  }
}

export default function startInputWatchdog() {
  if (typeof window === 'undefined' || window.__bhaInputWatchdog) {
    return;
  }
  window.__bhaInputWatchdog = state;

  const markInput = () => {
    state.lastInputAt = Date.now();
    state.recoveryAt = 0;
    if (state.bannerShown) {
      removeBanner();
    }
  };
  ['pointerdown', 'mousedown', 'keydown'].forEach((type) => {
    document.addEventListener(type, markInput, true);
  });
  ['pointermove', 'touchstart'].forEach((type) => {
    document.addEventListener(type, markInput, { capture: true, passive: true });
  });
  document.addEventListener('scroll', () => { state.lastScrollAt = Date.now(); }, true);
  window.addEventListener('wheel', () => { state.lastScrollAt = Date.now(); }, { capture: true, passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      state.lastHiddenAt = Date.now();
    }
  });

  setInterval(check, CHECK_EVERY_MS);
}
